import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_EU_TAXONOMY_ACTIVITY } from "../domain";

import { euTaxonomyCompanyActivityApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_DELETE_COMPANY_ACTIVITY = "DELETE_COMPANY_ACTIVITY";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const deleteCompanyActivity = async (companyActivityId: string): Promise<void> => {
  const response =
    await euTaxonomyCompanyActivityApi.euTaxonomyCompanyActivityControllerDeleteEuTaxonomyCompanyActivity(
      companyActivityId,
    );

  return response.data;
};

export const useDeleteCompanyActivity = (
  user: UserProfileDto | null,
): {
  deleteCompanyActivity: UseMutateFunction<void, Error, string>;
  deleteCompanyActivityEnabled: boolean;
  isSuccessDeleteCompanyActivity: boolean;
  isPendingDeleteCompanyActivity: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EU_TAXONOMY_ACTIVITY, ACTION_DELETE_COMPANY_ACTIVITY],
    mutationFn: enabled ? deleteCompanyActivity : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_EU_TAXONOMY_ACTIVITY] });
    },
  });

  return {
    deleteCompanyActivity: mutate,
    deleteCompanyActivityEnabled: enabled,
    isSuccessDeleteCompanyActivity: isSuccess,
    isPendingDeleteCompanyActivity: isPending,
  };
};
